type SentryModule = typeof import('@sentry/react');

let sentry: SentryModule | null = null;
const pending: unknown[] = [];

/** Report an error now if Sentry is ready, otherwise queue it until it loads. */
export function captureException(error: unknown) {
  if (sentry) sentry.captureException(error);
  else pending.push(error);
}

/** Load and initialise Sentry off the critical path. */
export function initMonitoring() {
  const env = import.meta.env;
  const dsn = env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  const load = () => {
    void import('@sentry/react').then((mod) => {
      mod.init({
        dsn,
        sendDefaultPii: true,
        environment: (env.VITE_APP_ENV as string | undefined) || 'development',
        tracesSampleRate: 1.0,
        profilesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        integrations: [mod.replayIntegration()],
      });
      sentry = mod;
      for (const e of pending.splice(0)) mod.captureException(e);
    });
  };

  const w = window as Window & { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number };
  if (typeof w.requestIdleCallback === 'function') {
    w.requestIdleCallback(load, { timeout: 4000 });
  } else {
    window.setTimeout(load, 1500);
  }
}
